<template>
    <div class="text-center">
        <v-dialog
            v-model="dialog"
            width="500"
        >
            <template v-slot:activator="{ on: menu, attrs }">
                <v-tooltip top>
                    <template v-slot:activator="{ on: tooltip }">
                        <v-btn
                            :disabled="!disableDelete"
                            color="red"
                            depressed
                            v-bind="attrs"
                            v-on="{ ...tooltip, ...menu }"
                        >
                            <v-icon
                                class="inline-icon"
                                style="color: white;"
                            >
                                mdi-delete-alert
                            </v-icon>
                        </v-btn>
                    </template>
                    <span>Delete</span>
                </v-tooltip>
            </template>

            <v-card class="dialog-content">
                <v-card-title class="text-h5 red darken-1">
                    Delete
                </v-card-title>

                <v-card-text class="dialog-message">
                    Are you sure you want to proceed?
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-btn
                        color="grey"
                        depressed
                        text
                        @click="closeDialog"
                    >
                        Cancel
                    </v-btn>
                    <v-spacer />
                    <v-btn
                        color="red"
                        depressed
                        text
                        @click="emitEvent"
                    >
                        Delete
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            disableDelete: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                dialog: false
            }
        },
        methods: {
            closeDialog() {
                this.dialog = false
            },
            emitEvent() {
                this.closeDialog()
                this.$emit('delete-event')
            }
        }
    }
</script>

<style scoped>
.darken-1 {
    color: white;
}

.dialog-content {
    display: flex;
    flex-direction: column;
}

.dialog-message {
    padding: 2rem 1rem !important;
}
</style>
